import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './contact-us.css'

const ContactUs = (props) => {
  return (
    <div className="contact-us-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="Contact-Us - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/contact-us"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-contact">
        <div className="hero-contact-media">
          <img
            alt="Cybersecurity expert working with advanced security systems"
            src="https://images.pexels.com/photos/5380594/pexels-photo-5380594.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="hero-contact-image"
          />
        </div>
        <div className="hero-contact-overlay"></div>
        <div className="hero-contact-content">
          <h1 className="hero-title">Get in Touch with Our Security Experts</h1>
          <p className="hero-subtitle">
            We&apos;re here to help secure your organization with
            enterprise-grade cybersecurity solutions. Let&apos;s start a
            conversation about protecting what matters most.
          </p>
          <div className="hero-contact-actions">
            <a href="#contact-form">
              <div className="btn-primary btn btn-lg">
                <span>Request Consultation</span>
              </div>
            </a>
            <a href="tel:+918050520087">
              <div className="btn btn-lg btn-outline">
                <span style={{ color: 'black' }}>Call Now</span>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section className="cta-methods">
        <div className="cta-methods-container">
          <div className="cta-methods-grid">
            <div className="cta-methods-card">
              <div className="cta-methods-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="cta-methods-title">Phone Support</h3>
              <a href="tel:+18005550123">
                <div className="cta-methods-link">
                  <span>+91 8050520087</span>
                </div>
              </a>
            </div>
            <div className="cta-methods-card">
              <div className="cta-methods-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="cta-methods-title">Email Support</h3>
              <a href="tel:+18005550123">
                <div className="cta-methods-link">
                  <span>Info@cysigil.com</span>
                </div>
              </a>
              <a href="tel:+18005550123">
                <div className="cta-methods-link">
                  <span>Sales@cysigil.com</span>
                </div>
              </a>
            </div>
            <div className="cta-methods-card">
              <div className="cta-methods-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M17.97 9.304A8 8 0 0 0 2 10c0 4.69 4.887 9.562 7.022 11.468m12.356-4.842a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"></path>
                    <circle r="3" cx="10" cy="10"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="cta-methods-title">Office Location</h3>
              <p className="cta-methods-description">India</p>
              <address className="cta-methods-address">
                <span>
                  {' '}
                  85/2, 1st Floor, 3rd Main Rd, Vijayanagar,
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>
                  {' '}
                  Bengaluru, Karnataka 560040.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>
                  <span>India</span>
                  <br></br>
                </span>
              </address>
            </div>
            <div className="cta-methods-card">
              <div className="cta-methods-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M17.97 9.304A8 8 0 0 0 2 10c0 4.69 4.887 9.562 7.022 11.468m12.356-4.842a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"></path>
                    <circle r="3" cx="10" cy="10"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="cta-methods-title">Office Location</h3>
              <p className="cta-methods-description">
                <span>UAE</span>
                <br></br>
              </p>
              <address className="cta-methods-address">
                <span> No 214, Invest Bank Building</span>
                <br></br>
                <span> Al Tawuun, Sharja</span>
                <br></br>
              </address>
            </div>
          </div>
        </div>
      </section>
      <section id="contact-form" className="contact-form-section">
        <div className="contact-form-container">
          <div className="contact-form-card">
            <div className="contact-form-header">
              <h2 className="section-title">Send Us a Message</h2>
              <p className="section-subtitle">
                Fill out the form below and our team will respond within 24
                hours
              </p>
            </div>
            <form
              action="/submit-contact"
              method="POST"
              data-form-id="62441237-38c1-44ef-8758-69f7ee835c9b"
              className="contact-form"
            >
              <div className="contact-form-row">
                <div className="contact-form-field">
                  <label htmlFor="firstName" className="contact-form-label">
                    First Name
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    required="true"
                    minlength="2"
                    className="contact-form-input"
                  />
                </div>
                <div className="contact-form-field">
                  <label htmlFor="lastName" className="contact-form-label">
                    Last Name
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    required="true"
                    minlength="2"
                    className="contact-form-input"
                  />
                </div>
              </div>
              <div className="contact-form-row">
                <div className="contact-form-field">
                  <label htmlFor="email" className="contact-form-label">
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required="true"
                    className="contact-form-input"
                  />
                </div>
                <div className="contact-form-field">
                  <label htmlFor="phone" className="contact-form-label">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    pattern="[0-9+\\-\\s()]&#123;10,&#125;"
                    className="contact-form-input"
                  />
                </div>
              </div>
              <div className="contact-form-field">
                <label htmlFor="company" className="contact-form-label">
                  Company Name
                </label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  className="contact-form-input"
                />
              </div>
              <div className="contact-form-field">
                <label htmlFor="service" className="contact-form-label">
                  Service of Interest
                </label>
                <select
                  id="service"
                  name="service"
                  required="true"
                  className="contact-form-select"
                >
                  <option value="true">Select a service</option>
                  <option value="soc">SOC as a Service</option>
                  <option value="vapt">VAPT as a Service</option>
                  <option value="ot-iot">OT &amp; IoT Security</option>
                  <option value="cloud">Cloud Security Assessment</option>
                  <option value="devsecops">DevSecOps Integration</option>
                  <option value="red-team">Red Team Exercises</option>
                  <option value="vciso">vCISO Services</option>
                  <option value="compliance">Security Compliance</option>
                  <option value="other">Other Consulting Services</option>
                </select>
              </div>
              <div className="contact-form-field">
                <label htmlFor="message" className="contact-form-label">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  required="true"
                  maxlength="1000"
                  minlength="20"
                  className="contact-form-textarea"
                ></textarea>
              </div>
              <div className="contact-form-checkbox">
                <input
                  type="checkbox"
                  id="consent"
                  name="consent"
                  required="true"
                />
                <label
                  htmlFor="consent"
                  className="contact-form-checkbox-label"
                >
                  I agree to receive communications from Cysigil Security
                  regarding my inquiry
                </label>
              </div>
              <button
                id="thq_button_TdgS"
                name="button"
                type="submit"
                className="btn-primary btn btn-lg contact-form-submit"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>
      <section className="features-credentials">
        <div className="features-credentials-container">
          <div className="features-credentials-header">
            <h2 className="section-title">Why Organizations Trust Cysigil</h2>
            <p className="section-subtitle">
              Enterprise-grade cybersecurity backed by industry certifications
              and proven expertise
            </p>
          </div>
          <div className="features-credentials-grid">
            <div className="features-credentials-card">
              <div className="features-credentials-icon">
                <svg
                  width="36"
                  xmlns="http://www.w3.org/2000/svg"
                  height="36"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m15.477 12.89l1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                    <circle r="6" cx="12" cy="8"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="features-credentials-title">
                Industry Certifications
              </h3>
              <p className="features-credentials-description">
                Our team holds ISO 27001, CISSP, CEH, OSCP, and CISM
                certifications ensuring the highest standards of security
                expertise.
              </p>
              <div className="features-credentials-badges">
                <span className="features-credentials-badge">ISO 27001</span>
                <span className="features-credentials-badge">
                  SOC 2 Type II
                </span>
                <span className="features-credentials-badge">PCI-DSS</span>
              </div>
            </div>
            <div className="features-credentials-card">
              <div className="features-credentials-icon">
                <svg
                  width="36"
                  xmlns="http://www.w3.org/2000/svg"
                  height="36"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <circle r="4" cx="9" cy="7"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="features-credentials-title">Experienced Team</h3>
              <p className="features-credentials-description">
                Over 15 years of combined cybersecurity experience with 50+
                security professionals dedicated to protecting your
                infrastructure.
              </p>
              <div className="features-credentials-stats">
                <div className="features-credentials-stat">
                  <strong>30+</strong>
                  <span>Security Experts</span>
                </div>
                <div className="features-credentials-stat">
                  <strong>15+</strong>
                  <span>Years Experience</span>
                </div>
              </div>
            </div>
            <div className="features-credentials-card">
              <div className="features-credentials-icon">
                <svg
                  width="36"
                  xmlns="http://www.w3.org/2000/svg"
                  height="36"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="features-credentials-title">
                Proven Track Record
              </h3>
              <p className="features-credentials-description">
                Successfully protected 500+ organizations across healthcare,
                finance, government, and technology sectors globally.
              </p>
              <div className="features-credentials-stats">
                <div className="features-credentials-stat">
                  <strong>100+</strong>
                  <span>Clients Protected</span>
                </div>
                <div className="features-credentials-stat">
                  <strong>98%</strong>
                  <span>Client Retention</span>
                </div>
              </div>
            </div>
            <div className="features-credentials-card">
              <div className="features-credentials-icon">
                <svg
                  width="36"
                  xmlns="http://www.w3.org/2000/svg"
                  height="36"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-credentials-title">
                Case Study Highlights
              </h3>
              <p className="features-credentials-description">
                Reduced security incidents by 87% for clients and prevented 1M$
                in potential breach damages through proactive threat detection.
              </p>
              <div className="features-credentials-stats">
                <div className="features-credentials-stat">
                  <strong>87%</strong>
                  <span>Incident Reduction</span>
                </div>
                <div className="features-credentials-stat">
                  <strong>$45M+</strong>
                  <span>Damages Prevented</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="contact-us-container2">
        <div className="contact-us-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.hero-contact-content, .cta-methods-card, .about-office-item, .features-credentials-card, .services-overview-card, .compliance-logos-item {
  transition: none;
}
.services-overview-link:hover {
  gap: var(--spacing-sm);
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="contact-us-container4">
        <div className="contact-us-container5">
          <Script
            html={`<script defer data-name="testimonials-scroll">
(function(){
  const testimonialsScroll = document.querySelector(".testimonials-rail-scroll")

  if (testimonialsScroll) {
    let isDown = false
    let startX
    let scrollLeft

    testimonialsScroll.addEventListener("mousedown", (e) => {
      isDown = true
      startX = e.pageX - testimonialsScroll.offsetLeft
      scrollLeft = testimonialsScroll.scrollLeft
    })

    testimonialsScroll.addEventListener("mouseleave", () => {
      isDown = false
    })

    testimonialsScroll.addEventListener("mouseup", () => {
      isDown = false
    })

    testimonialsScroll.addEventListener("mousemove", (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - testimonialsScroll.offsetLeft
      const walk = (x - startX) * 2
      testimonialsScroll.scrollLeft = scrollLeft - walk
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default ContactUs
